module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_number-9ec03da739ba43d690bc96bad22797b5.jpg";